import { E50_FORM_URL } from "@util/constant";

/**
 * component to render in Applications tab at How to Nominate page E50
 */
const ApplicationsPage = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-250 p-4 font-public-sans"
      data-testid="applications-page-component"
    >
      <p className="mb-12">
        Applications for 2026 are now open. Please submit your application via
        the online form&nbsp;
        <a
          href={E50_FORM_URL}
          target="_blank"
          className="text-blue-175"
          rel="noreferrer"
        >
          here
        </a>{" "}
        by <strong>30 June 2026</strong>.
      </p>

      <p className="pb-12">
        For more information, please email&nbsp;
        <a
          className="font-bold text-blue-175 underline hover:text-gray-750"
          target="_blank"
          rel="noreferrer"
          href="mailto:enterprise50@kpmg.com.sg"
        >
          enterprise50@kpmg.com.sg
        </a>
        .
      </p>
    </div>
  );
};

export default ApplicationsPage;
